import { Button, Grid } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import User from 'classes/User';
import { HotjarEvents, submitEvent } from 'hotjar';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { listCurrency } from 'store/Orbita/Currency/actions';
import { listCategories } from 'store/Orbita/Product/actions';
import { EProductType } from 'v2/interfaces/product';
import { npsService } from 'v2/services/nps';

import CreateVariation from './CreateVariation';
import ProductDetails from './ProductDetails';
import SectionMore from './SectionMore';
import ShareableLinks from './ShareableLinks';
import styles from './styles';
import { SolidaritySquadModal } from '../../SolidaritySquad/Modal';

import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

const CREATE_PRODUCT_FEEDBACK_ID = 796843;
const CREATE_PRODUCT_EXPIRATION_IN_DAYS = 90;

interface IProps extends StyledComponentProps, DispatchProp<any> {
  product: IProduct;
  currentUser: IUser;
}

interface IStates {
  isSolidaritySquadModalOpen: boolean;
}

class Preview extends React.Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSolidaritySquadModalOpen: true,
    };
  }

  async componentDidMount() {
    const lastAnswer = await npsService.getSurveyLastAnswer(CREATE_PRODUCT_FEEDBACK_ID);
    if (lastAnswer) {
      const isSurveyExpired = lastAnswer.answered && lastAnswer.days_count >= CREATE_PRODUCT_EXPIRATION_IN_DAYS;
      const shouldShowSurvey = !lastAnswer.answered || isSurveyExpired;
      if (shouldShowSurvey) {
        submitEvent(HotjarEvents.PRODUCT_CREATED);
      }
    }
  }

  handleCloseSolidaritySquadModal = () => {
    this.setState({
      isSolidaritySquadModalOpen: false,
    });
  };

  handleResetWizard = () => {
    const WIZARD_INITIAL_STEP = 1;

    try {
      this.props.dispatch({ type: 'RESET_PRODUCT_WIZARD_NP' });
      this.props.dispatch({ type: 'RESET_WIZARD_NP', WIZARD_INITIAL_STEP });
      this.props.dispatch({ type: 'RESET_VALUE_WIZARD_NP', WIZARD_INITIAL_STEP });
      this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
      this.props.dispatch(listCategories());
      this.props.dispatch(listCurrency());

      const currentUrl = window.location.host;

      window.history.replaceState(null, null, `${currentUrl}/producer/product/newproduct`);
    } catch (error) {}
  };

  render() {
    const { product, classes } = this.props;
    const { isSolidaritySquadModalOpen } = this.state;

    return (
      <>
        <SolidaritySquadModal isOpen={isSolidaritySquadModalOpen} handleClose={this.handleCloseSolidaritySquadModal} productId={product.id} />

        <div className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className='title'>Tudo certo!</div>
              <p className='subtitle'>Seu produto {product.title} está em moderação. Mas você já pode começar a vender.</p>
            </Grid>

            <ProductDetails product={product} />

            {product.type !== EProductType.PHYSICAL && <ShareableLinks productId={product.hash ?? product.id} />}

            <CreateVariation product={product} />
            <SectionMore product={product} />
          </Grid>

          <Grid className='footer' container justifyContent='flex-end' spacing={2}>
            <Grid item>
              <Link id='link-go-to-products' to='/producer/product/myproducts'>
                <Button variant='outlined'>Ir para meus produtos</Button>
              </Link>
            </Grid>
            <Grid item>
              <Button id='link-go-to-new-product' variant='contained' color='primary' onClick={this.handleResetWizard}>
                Cadastrar novos produtos
              </Button>
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    product: state.components.newProductWizard.product,
    currentUser: new User(state.orbita.User.user),
  };
}

export default styles(connect(mapStateToProps)(Preview));
